export default __webpack_public_path__ + "static/media/flooding.54b3198c.png";